import * as React from "react";
import i18n from "i18n";
import { Link } from "react-router-dom";
import { Grid, Typography, withStyles } from "@material-ui/core";
import InputSearch from "common/components/fields/InputSearch";
import { CompositionStore } from "modules/composition/CompositionStore";

const styles = (theme) => ({
  container: {
    backgroundColor: theme.palette.secondary.light,
    borderBottom: "1px solid #f2f2f2",
    height: "64px",
  },
  title: {
    lineHeight: "64px",
    fontSize: "16px",
    fontFamily: "Raleway",
    display: "inline-block",
    cursor: "pointer",
    textAlign: "center" as any,
    position: "relative" as any,
  },
  newProject: {
    left: "100%",
    top: 0,
    cursor: "auto",
    position: "absolute" as any,
    whiteSpace: "nowrap" as any,
  },
  gridSearch: {
    display: "table",
    height: "100%",
    "& > :first-child": {
      display: "table-cell",
      height: "100%",
      verticalAlign: "middle",
    },
  },
  link: {
    textDecoration: "unset",
    color: "#212121",
    borderBottom: "1px solid transparent",
    transition: "all 0.3s ease-in",
    paddingBottom: "5px",
    "&:hover": {
      borderColor: "#212121",
    },
  },
});

type IProps = {
  classes: any;
};

class SearchHeader extends React.Component<IProps> {
  handleInputChange = (value) => value;
  handleCleanFilter = () => {};

  componentWillUnmount() {
    document.title = "Rubk";
  }

  render() {
    const { classes } = this.props,
      {
        benchComposition: {
          data: { name },
        },
      } = CompositionStore;
    document.title = `Rubk - ${name}`;
    return (
      <Grid container className={classes.container}>
        <Grid item xs={2} style={{ textAlign: "center" }}>
          <Typography className={classes.title}>
            <Link
              to={"/menu/rateLibraries"}
              className={classes.link}
              onClick={() => (CompositionStore.loading = false)}
            >
              {i18n.menu.rateLibrary}
            </Link>
            <span className={classes.newProject}>
              &ensp;{">"}&ensp;
              <span style={{ fontWeight: 700 }}>{name}</span>
            </span>
          </Typography>
        </Grid>
        <Grid item xs={8} />
        {/* <Grid item xs={4} className={classes.gridSearch}>
					<div>
						<InputSearch
							disabled={false}
							placeholder={i18n.find}
							handleChange={this.handleInputChange}
							handleClean={this.handleCleanFilter}
						/>
					</div>
				</Grid> */}
        <Grid item xs={2} />
      </Grid>
    );
  }
}

export default withStyles(styles)(SearchHeader);



// WEBPACK FOOTER //
// ./src/modules/composition/components/layouts/SearchHeader.tsx